import { IDocuments } from 'models';

export const findDocument = (documents?: IDocuments[], documentType?: number) => {
  if (typeof documents === 'object') {
    return documents?.find(item => item?.documentType === documentType);
  }
  return documents;
};
